(function(){
  if (window.__gbSearchFixInit) return; window.__gbSearchFixInit = true;
  var GLUED_WORDS = {
    'onepiece': 'one piece',
    'dragonball': 'dragon ball'
  };
  function normalize(term) {
    var lower = term.toLowerCase();
    if (GLUED_WORDS[lower]) return GLUED_WORDS[lower];
    var m = term.match(/^([a-z]{1,4})(\d{1,3}[a-z]?)$/i);
    if (!m) return null;
    return m[1] + '-' + m[2];
  }
  document.addEventListener('input', function(e){
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
    var pc = input.closest('predictive-search-component');
    var resultsEl = pc && pc.querySelector('#predictive-search-results, .predictive-search-results');
    if (!pc || !resultsEl) return;
    var raw = input.value.trim();
    var fixed = normalize(raw);
    if (!fixed) return;
    if (input.dataset.gbLastFixed === raw) return;
    var attempted = raw;
    var obs = new MutationObserver(function(muts, observer){
      if (input.value.trim() !== attempted) { observer.disconnect(); return; }
      var noResults = resultsEl.querySelector('.predictive-search-results__no-results');
      if (!noResults) { observer.disconnect(); return; }
      observer.disconnect();
      input.dataset.gbLastFixed = attempted;
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, fixed);
      input.dispatchEvent(new InputEvent('input', {bubbles:true, inputType:'insertText'}));
    });
    obs.observe(resultsEl, {childList:true, subtree:true});
    setTimeout(function(){ obs.disconnect(); }, 3000);
  }, true);
})();
